<template>
	<div class="home">
		<div class="title">{{ username }}，欢迎登录供应链管理系统v2.5</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters(['username'])
	},
	components: {}
}
</script>
<style lang="scss" scoped>
.home {
	.title {
		text-align: left;
		padding: 16px;
	}
}
</style>
